import getEnvironment from "./getEnvironment";

export const IS_PRODUCTION = getEnvironment() === "production";

export const UAT_MAGNOLIA_ROOT_URL = "https://cms.uat.britishcarauctions.net";

export const MAGNOLIA_ROOT_URL = IS_PRODUCTION
  ? "https://www.bca.co.uk"
  : UAT_MAGNOLIA_ROOT_URL;

export const AUCTION_MANAGEMENT_ROOT_URL = IS_PRODUCTION
? "https://uk-sale-management.bca.com"
: "https://uat-uk-sale-management.bca.com";

// Pages

export const SEARCH_URL = `${MAGNOLIA_ROOT_URL}/search`;

export const VENDOR_PORTAL_URL = `${MAGNOLIA_ROOT_URL}/mybca/sell/vehicles`;